import Protektor from '@iris-platform/protektor';
import { map } from 'ramda';

export const addMapping = rmMapping => Protektor.resourceModels(
  rmMapping.resource,
  rmMapping.models,
);

export const setResourceModelMappings = mappings => Promise.all(map(addMapping, mappings));

export default {
  addMapping,
  setResourceModelMappings,
};
